import { FC } from 'react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { TextLink } from '@crehana/ui';

const Link: FC<
  React.PropsWithChildren<{ href?: string; label?: string; navLink?: string }>
> = ({ href, label, navLink }) =>
  navLink ? (
    <RouterLink to={navLink}>
      <TextLink label={label || href} type="body3" />
    </RouterLink>
  ) : (
    <TextLink
      href={href && href.includes('@') ? `mailto:${href}` : href}
      label={label || href}
      type="body3"
    />
  );

export default Link;
